<template>
  <div class="flex flex-wrap items-baseline gap-x-4">
    <span v-bind="priceAttrs" class="heading-2 text-static-success-hi">
      {{ i18n.price(price) }}
    </span>

    <slot name="label" />
  </div>
</template>

<script lang="ts" setup>
import type { Price } from '@backmarket/core-types/Price'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

defineProps<{
  price: Price
  priceAttrs?: Record<string, unknown>
}>()

const i18n = useI18n()
</script>
